import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface ManualMeetingDeleteDialogProps {
  open: boolean;
  failed: boolean;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The confirm in front of removing a meeting the user added themselves.
 *
 * It says what goes with it. The preparation and the verslag live on the
 * meeting, so deleting it takes them along — and unlike a calendar meeting
 * there is no sync that would ever bring it back.
 */
export function ManualMeetingDeleteDialog({
  open,
  failed,
  pending,
  onConfirm,
  onCancel,
}: ManualMeetingDeleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.manual_meeting_delete_title()}</DialogTitle>
        </DialogHeader>

        <div className='flex flex-col gap-2.5 px-5 py-4'>
          <DialogDescription>{m.manual_meeting_delete_body()}</DialogDescription>
          {failed && (
            <p role='alert' className='text-sm text-danger'>
              {m.manual_meeting_delete_failed()}
            </p>
          )}
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onCancel}>
            {m.manual_meeting_cancel()}
          </Button>
          <Button size='sm' variant='danger' disabled={pending} onClick={onConfirm}>
            {m.manual_meeting_delete_confirm()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
